<div>
  <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl'"
       ng-include="'orders/orders-other.tpl.html'">
  </div>
  <div ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation == 'sl'"
       ng-include="'orders/orders-slo.tpl.html'">
  </div>
</div>
